

import React from 'react';

const Guarantee = () => {
  return (
    <div>
      <section className="banner gurantee-banner">
        <div className="container">
          <div className="row  ">
            <div className="col-lg-6 col-md-6 col-sm-12">
              <h1>The iCause Warranty</h1>
              <p className="">t iCause, our role in the fundraising process is one we take seriously. We’ll do everything we can to make your fundraising totals get higher – and go further.</p>
              <button type="button" className="btn btn-success btn_hover">GET STARTED</button>
            </div>
          </div>
        </div>
      </section>

      <section className="donate-section iCause-Partners gurantee-sec-2">
        <div className='container'>
          <div className='row'>
            <div className='col-lg-5 col-md-4'>
              <div className="card img-card">
                <img src="/images/gurantee-sec-2-img-1.png" className="img-fluid" alt="img" />
                <div className="sm-img">
                  <img src="/images/gurantee-sec-2-img-2.png" className="img-fluid" alt="img" />
                </div>
              </div>
            </div>
            <div className='col-lg-7 col-md-8 pl-md-5'>
              <div className="text-box">
              <h5 className="text-grn">A CHARITY WITH MISSION</h5>
              <h3 className="main-heading    mt-md-0">What is the iCause Warranty ?</h3>
              <p className="font-weight-bold">“Generosity consists not of the sum given, but the manner in which it is bestowed.”</p>
              <p className="">Our vision for a world is where no one is needlessly blind, and indigenous Australians enjoy the same health and life expectancy as other Australians. Our vision for a world is where no one is needlessly blind, and indigenous Australians.</p>
              <button type="button" className="btn btn-outline-dark">READ MORE</button>
              </div>
            </div>

          </div>
        </div>
      </section>
      <section className="donate-section iCause-Partners gurantee-sec-3">
        <div className='container'>
          <div className='row d-flex align-items-center'>

            <div className='col-lg-7 col-md-12'>
            <div className="text-box">
              <h5 className="text-grn">A CHARITY WITH MISSION</h5>
              <h3 className="main-heading    mt-md-0">Are You Donors?</h3>
              <p className="font-weight-bold">“Generosity consists not of the sum given, but the manner in which it is bestowed.”</p>
              <p className="">Our vision for a world is where no one is needlessly blind, and indigenous Australians enjoy the same health and life expectancy as other Australians. Our vision for a world is where no one is needlessly blind, and indigenous Australians.</p>
              <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut laboret dolore magna aliqua ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
              <button type="button" className="btn btn-outline-dark mb-3">READ MORE</button>
              </div>
            </div>
            <div className='col-lg-5 col-md-12'>
              <div className="card img-card dual-img">
                  <img src="/images/gurantee-sec-3-img-1.png" className="img-fluid" alt="img" />
                  <div className="sm-img">
                    <img src="/images/gurantee-sec-3-img-2.png" className="img-fluid" alt="img" />
                  </div>
                </div>
            </div>

          </div>
        </div>
      </section>
      <section className="donate-section iCause-Partners gurantee-sec-4">
        <div className='container'>
          <div className='row'>
            <div className='col-lg-6 col-md-5 order-md-1 order-sm-2'>
              <div className="img-box">
                <img src="/images/gurantee-sec-4-img-1.png" className="img-fluid" alt="img" />
              </div>
            </div>
            <div className='col-lg-6 col-md-7 order-md-2 order-sm-1'>
              <div className="text-box">
                <h5 className="text-grn">A CHARITY WITH MISSION</h5>
                <h3 className="main-heading    mt-md-0">Are You Donors?</h3>
                <p className="font-weight-bold">“Generosity consists not of the sum given, but the manner in which it is bestowed.”</p>
                <p className="">Our vision for a world is where no one is needlessly blind, and indigenous Australians enjoy the same health and life expectancy as other Australians. Our vision for a world is where no one is needlessly blind.</p>
                <button type="button" className="btn btn-outline-dark">READ MORE</button>
              </div>
            </div>


          </div>
        </div>
      </section>
      <section className="accordion gurantee-sec-5">
        <div className="container">
          <div className="top-text">
            <h5 className="text-grn text-center">A CHARITY WITH MISSION</h5>
            <h3 className="main-heading mt-md-0 text-center mb-4">Warranty Conditions</h3>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div id="accordion" className="accordion-wrap">
                <div className="card">
                  <div className="card-header">
                    <h5 className="mb-0">
                      <button className="btn btn-link" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                        <i className="fa fa-caret-down"></i>Some Outstanding Activities 1
                      </button>
                    </h5>
                  </div>

                  <div id="collapseOne" className="collapse show" data-parent="#accordion">
                    <div className="card-body">
                      <p>Section 2 applies to campaign donors. Donors may be entitled to receive a full refund of any donation when there is misuse. Our definitions of “misuse” are as following:</p>
                      <p>• Funds fail to be delivered to the stated beneficiary by the campaign organiser.</p>
                      <p>• The content of a campaign is found to be inaccurate with regard to any material facts relating to the beneficiary, the campaign, or the campaign organiser themselves – and that misrepresentation encourages a donor to give to the campaign in good faith.</p>
                      <p>• The content of a campaign is found to be inaccurate with regard to any material facts relating to the beneficiary, the campaign, or the campaign organiser themselves – and it leads to the intended recipient or the organiser of the campaign being charged with a criminal offence in direct relation to misrepresentations made within the campaign. When misuse does occur, and iCause solely deems that to be the case, iCause will either: Refund any donation you made to the cause through this platform (to a maximum value of $1,000 for each donor during each campaign). Or:</p>
                      <p>If iCause deems it to be more appropriate, iCause will award the donor a credit equivalent to the refund amount which they can use to donate to an alternative campaign.</p>
                      <p>Where misuse amounts to a failure of the campaign organiser to deliver any raised funds, we may redirect those funds to the correct destination, as stated in the original campaign. iCause reserves the right to be the sole decider of the outcome of any disputes, and any decisions made by iCause shall be final. Donors may not seek a credit or a refund in the following instances:</p>
                      <p>• For any monies donated to your own campaign.</p>
                      <p>• For any donations that did not happen on the iCause platform.</p>
                      <p>• If you merely regret making a donation to a cause on the platform.</p>
                      <p>• If you have a personal disagreement with, or simply because you have or develop a personal dislike of any beneficiary or of any campaign organiser using the platform.</p>
                      <p>• If you don’t agree with how another party on the website intends to use funds that have been raised beyond the intended scope of any fundraising target.</p>
                      <p>• If you disagree with iCause for any reason.</p>
                      <p>• For any other reason that is not based on a genuine and provable belief that misuse did actually occur. </p>
                    </div>
                  </div>
                </div>
                <div className="card">
                  <div className="card-header">
                    <h5 className="mb-0">
                      <button className="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                      <i className="fa fa-caret-down"></i> Some Outstanding Activities 2
        </button>
                    </h5>
                  </div>
                  <div id="collapseTwo" className="collapse" data-parent="#accordion">
                    <div className="card-body">
                      Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.
      </div>
                  </div>
                </div>
                <div className="card">
                  <div className="card-header">
                    <h5 className="mb-0">
                      <button className="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                      <i className="fa fa-caret-down"></i>Some Outstanding Activities 3
        </button>
                    </h5>
                  </div>
                  <div id="collapseThree" className="collapse" data-parent="#accordion">
                    <div className="card-body">
                      Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.
      </div>
                  </div>
                </div>
                <div className="card">
                  <div className="card-header">
                    <h5 className="mb-0">
                      <button className="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse4" aria-expanded="false" aria-controls="collapse4">
                      <i className="fa fa-caret-down"></i>Some Outstanding Activities 4
        </button>
                    </h5>
                  </div>
                  <div id="collapse4" className="collapse" data-parent="#accordion">
                    <div className="card-body">
                      Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.
      </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="the-wold-better gurantee-sec-6">
        <div className="container text-center">
          <div className="row">
            <div className="col-lg-10 col-md-12 mx-auto">
              <h1>Together To Help The World Better!<span> Let's Make This Happen</span></h1>
              <p>Please help us change lives around the world.</p>
              <button className="btn btn-success my-2 my-sm-0 text-uppercase" type="submit">GET STARTED</button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Guarantee;
